// extracted by css-extract-rspack-plugin
export default {"rivers":"WorkflowSection-module__rivers__yc5FQxR","bento":"WorkflowSection-module__bento__ZfY5p18"};